import type { BreadcrumbItem, FolderTreeNode } from '../../types';

// 创建根文件夹节点的辅助函数
export const createRootFolder = (rootFolder?: BreadcrumbItem): FolderTreeNode => ({
  id: rootFolder?.id || '',
  name: rootFolder?.name || '',
  type: 'folder',
  parent_id: '',
  created_at: '',
  last_open_at: '',
  depth: 0,
  size: '0',
});
